export default __webpack_public_path__ + "static/media/step1.928c5913.png";